import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { TransferPanelComponent } from './transfer-panel.component';
import { TransferPanelService } from './transfer-panel.service';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { LoadingModule } from '../loading/loading.module';
import { OperatorsListModule } from '../operators-list/operators-list.module';
import { OperatorsService } from 'common/operators/operators.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SvgIconModule,
    TranslateModule,
    LoadingModule,
    OperatorsListModule,
    MatInputModule
  ],
  declarations: [
    TransferPanelComponent
  ],
  providers: [
    TransferPanelService,
    OperatorsService
  ],
  exports: [
    TransferPanelComponent
  ]
})

export class TransferPanelModule {}
